import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "error-warning-update" }
const _hoisted_2 = { class: "h4" }
const _hoisted_3 = { class: "line" }
const _hoisted_4 = { class: "line" }
const _hoisted_5 = { class: "d-inline-block" }
const _hoisted_6 = { class: "form-check" }
const _hoisted_7 = ["name", "id", "value", "onUpdate:modelValue"]
const _hoisted_8 = ["for"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  class: "line",
  style: {"width":"80%"}
}
const _hoisted_11 = { class: "mt-3" }

import {computed, ref, watch, onMounted} from "vue";
import {useGlobalMessagesStore} from "@/stores/globalMessagesStore";
import axios from "axios";
import {handleError} from "@/stores/storeHelper";
import {DismissError} from "@/types";
import {number, object, string} from "yup";
import {BTextarea} from "./Fields";
import {FormModal} from "./Misc";
import {useFormValidation} from "@/validation";

export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorsAndWarningsUpdate',
  props: /*@__PURE__*/_mergeModels({
    item: {},
    url: {},
    dataset: {},
    uploadHeaders: { default: {} }
  }, {
    "modelValue": { type: Boolean },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["dismiss"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const {handleSubmit, errors, resetValidation} = useFormValidation();
const model = _useModel<boolean>(__props, "modelValue");
const item = ref({} as DismissError);
const schema = object<DismissError>({
    status: number().required().label("Status"),
    explanation: string().nullable()
        .label("Explanation/Justification")
        .when([], {
            is: () => item.value.status == 1,
            then: (schema) => schema.required(),
        }),
});

const globalMessages = useGlobalMessagesStore();

const props = __props;

const emit = __emit;

var dataItem = ref({} as any);

const statusList = computed(() => {
    return [
        {id: "unresolved", text: "Unresolved", value: "0"},
        {id: "dismissed", text: props.item.errorType == "Warning" ? "Cleared" : "Dismissed", value: "1"},
    ];
});

const updateModalTitle = computed(() => {
    if (dataItem.value.errorType == "Warning") {
        return "Warning Status Update";
    } else {
        return "Error Status Update";
    }
});

const incidentNumberLabel = computed(() => {
    if (props.dataset?.toLocaleLowerCase() == "communityPolicing") {
        return "Stop Number";
    }
    return "Incident Number";
});
const typeAndCode = computed(() => {
    return `${dataItem.value["errorType"]} ${dataItem.value["errorCode"]}`;
});
const errorDesc = computed(() => {
    return dataItem.value["description"];
});
const idValue = computed(() => {
    return props.dataset == "communityPolicing" ? dataItem.value["stopNumber"] : dataItem.value["incidentNumber"];
});

const dismiss = async () => {
    let dataToPost = {
        id: dataItem.value.id,
        status: item.value.status,
        explanation: item.value.explanation,
        code: dataItem.value.errorCode,
    };

    if (await handleSubmit(schema, item.value)) {
        try {
            await axios.post(props.url, dataToPost, {
                headers: props.uploadHeaders,
            });
            globalMessages.push({message: "Error or warning updated successfully.", type: "success"});
        } catch (error) {
            handleError(error);
            throw error;
        } finally {
            handleDismissClick();
        }
    }
};
function handleDismissClick() {
    model.value = false;
    emit("dismiss");
}

watch(
    () => props.item,
    (newItem, prevItem) => {
        resetValidation();
        if (newItem != null) {
            dataItem.value = newItem;

            if (dataItem.value["isAcknowledged"]) {
                item.value.status = 1;
            } else {
                item.value.status = 0;
            }

            item.value.explanation = dataItem.value["explanation"];
        } else {
            item.value = {} as DismissError;
        }
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(FormModal), {
    title: updateModalTitle.value,
    modelValue: model.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
    "submit-button": "Update",
    onSubmit: dismiss,
    "modal-style": 'max-width:950px'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "h4" }, "Agency Name:", -1)),
          _createTextVNode(" " + _toDisplayString(_unref(dataItem).agency), 1)
        ]),
        _createElementVNode("div", null, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "h4" }, "Agency Ori:", -1)),
          _createTextVNode(" " + _toDisplayString(_unref(dataItem).ori), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(incidentNumberLabel.value) + ":", 1),
          _createTextVNode(" " + _toDisplayString(idValue.value), 1)
        ]),
        _createElementVNode("div", null, [
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "h4" }, "Description:", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(typeAndCode.value), 1),
            _createTextVNode(" - " + _toDisplayString(errorDesc.value), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "h4" }, "Status:", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusList.value, (status) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: status.id,
                    id: status.id,
                    value: status.value,
                    "onUpdate:modelValue": ($event: any) => ((item.value.status) = $event)
                  }, null, 8, _hoisted_7), [
                    [_vModelRadio, item.value.status]
                  ]),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: status.id
                  }, _toDisplayString(status.text), 9, _hoisted_8)
                ]))
              }), 256))
            ])
          ])
        ]),
        (item.value.status == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _cache[6] || (_cache[6] = _createElementVNode("label", {
                for: "explanation",
                class: "h4"
              }, "Explanation/Justification:", -1)),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(BTextarea), {
                  name: "explanation",
                  modelValue: item.value.explanation,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.explanation) = $event)),
                  error: _unref(errors).explanation,
                  rows: 5
                }, null, 8, ["modelValue", "error"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(dataItem).isAcknowledged && item.value.status == 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_11, [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "h4" }, "Action date:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(dataItem).acknowledgedOn), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "h4" }, "Actioned by:", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(dataItem).acknowledgedBy), 1)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})